import { FOOTER_MJML } from "../common/footer";
import { TRANSACTIONAL_HEADER } from "../common/header";

export const invitation = `
<mjml>
  <mj-head>
    <mj-title>You're Invited!</mj-title>
    <mj-preview>Join us for a special event</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
  </mj-head>
  <mj-body>
    ${TRANSACTIONAL_HEADER("You're Invited!", "Virtual Conference 2023")}
    
    <mj-section background-color="#ffffff" padding="30px 0">
      <mj-column>
        <mj-text font-size="26px" color="#333333" font-weight="bold" align="center">Virtual Conference 2023</mj-text>
        <mj-divider border-color="#6c757d" border-width="2px" width="100px" />
        <mj-text font-size="18px" color="#555555" align="center" padding-top="10px">October 15, 2023 | 9:00 AM - 5:00 PM</mj-text>
        <mj-text font-size="18px" color="#555555" align="center">Virtual Event - Access from Anywhere</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 0 30px">
      <mj-column>
        <mj-image src="https://via.placeholder.com/600x300?text=Conference+Banner" alt="Conference Banner" />
        <mj-text font-size="18px" color="#333333" padding-top="20px">Join us for an inspiring day of industry insights, networking opportunities, and expert speakers. This virtual conference will bring together professionals from around the world to explore the latest trends and innovations.</mj-text>
        <mj-button background-color="#6c757d" color="#ffffff" href="#" border-radius="4px" width="200px">Register Now</mj-button>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="30px">
      <mj-column width="100%">
        <mj-text font-size="24px" color="#333333" font-weight="bold" align="center">Featured Speakers</mj-text>
        <mj-divider border-color="#6c757d" border-width="1px" width="80px" />
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="0 0 30px">
      <mj-column width="33%">
        <mj-image src="https://via.placeholder.com/150?text=Speaker+1" alt="Speaker 1" width="150px" border-radius="75px" />
        <mj-text font-size="18px" font-weight="bold" align="center">Jane Doe</mj-text>
        <mj-text font-size="14px" align="center">CEO, Example Company</mj-text>
      </mj-column>
      <mj-column width="33%">
        <mj-image src="https://via.placeholder.com/150?text=Speaker+2" alt="Speaker 2" width="150px" border-radius="75px" />
        <mj-text font-size="18px" font-weight="bold" align="center">John Smith</mj-text>
        <mj-text font-size="14px" align="center">CTO, Tech Innovations</mj-text>
      </mj-column>
      <mj-column width="33%">
        <mj-image src="https://via.placeholder.com/150?text=Speaker+3" alt="Speaker 3" width="150px" border-radius="75px" />
        <mj-text font-size="18px" font-weight="bold" align="center">Sarah Johnson</mj-text>
        <mj-text font-size="14px" align="center">Marketing Director, Global Brand</mj-text>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "invitation",
  name: "Event Invitation",
  category: "events",
  description:
    "A professional event invitation with all the essential details, perfect for webinars, conferences, and other corporate events.",
  features: [
    "Event branding",
    "Date and time details",
    "Featured speakers section",
    "Registration button",
    "Event agenda",
  ],
  subject: "You're Invited!",
  subTitle: "Join us for a special event",
  mjmlTemplate: invitation,
};
